setPromise